// F1 Fantasy Tool - Fantasy F1 analytics and team optimization platform
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const f1FantasyTool: Tool = {
  id: "f1-fantasy",
  name: () => m.tool_f1_fantasy_name(),
  description: () => m.tool_f1_fantasy_description(),
  icon: "/f1-car-side-small.png",
  basePath: "/f1-fantasy",
  status: "stable",
  tags: ["f1", "fantasy", "analytics", "simulation", "optimization"],
  pages: [
    {
      name: () => "Home",
      path: "/f1-fantasy",
      description: () => "F1 Fantasy overview and news",
      icon: "🏁",
    },
    {
      name: () => "Apex Team",
      path: "/f1-fantasy/apex-team",
      description: () => "Best team optimizer for next race",
      icon: "🏆",
    },
    {
      name: () => "Budget Boost",
      path: "/f1-fantasy/budget-boost",
      description: () => "Price predictions and value picks",
      icon: "💰",
    },
    {
      name: () => "Fantasy Points",
      path: "/f1-fantasy/fantasy-points",
      description: () => "Fantasy points breakdown by race",
      icon: "⭐",
    },
    {
      name: () => "Standings",
      path: "/f1-fantasy/standings",
      description: () => "Driver and constructor standings",
      icon: "📊",
    },
    {
      name: () => "Statistics",
      path: "/f1-fantasy/statistics",
      description: () => "Deep driver and constructor stats",
      icon: "📈",
    },
  ],
};
